import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref } from 'vue';
import { fabric } from 'fabric';

import { NkFabricRect, NkFabricText } from '@/core/components';


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageAssemblerFabricImageInfo',
  props: {
  text: {
    type: String,
    required: true,
  },
  line: {
    type: Number,
    default: 0,
  },
  fontSize: {
    type: Number,
    default: 12,
  },
  fontFamily: {
    type: String,
    default: 'monospace',
  },
  lineHeight: {
    type: Number,
    default: 12,
  },
  lineSpacing: {
    type: Number,
    default: 2,
  },
  padding: {
    type: Number,
    default: 8,
  },
},
  setup(__props) {

const props = __props



const rectRef = ref();
const textRef = ref();

onMounted(() => {
  Promise.all([
    rectRef.value.deferredObject.promise,
    textRef.value.deferredObject.promise,
  ])
    .then(([rect, text]: fabric.Object[]) => {
      text.on('changed', () => {
        rect.set({
          width: (text.width || 0) + props.padding * 2,
        });
      });
      rect.set({
        width: (text.width || 0) + props.padding * 2,
      });
    });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(NkFabricRect), {
      ref_key: "rectRef",
      ref: rectRef,
      options: {
          fill: 'black',
          opacity: .8,
          top: props.line * (__props.lineHeight + __props.lineSpacing),
          width: 300,
          height: __props.lineHeight,
        },
      position: 0
    }, null, 8, ["options"]),
    _createVNode(_unref(NkFabricText), {
      ref_key: "textRef",
      ref: textRef,
      options: {
            fontFamily: __props.fontFamily,
            left: props.padding,
            originY: 'top',
            originX: 'left',
            fontSize: props.fontSize,
            height: props.lineHeight,
            top: (props.lineHeight - props.fontSize) / 2 + props.line * (props.lineHeight + props.lineSpacing),
            fill: 'white',
          },
      position: 1,
      text: props.text
    }, null, 8, ["options", "text"])
  ], 64))
}
}

})